import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { AppTester } from "../../../supporting";
import { useTranslation } from "react-i18next";
import { LayoutConst } from 'core';

const Wrapper = styled(FlexBox)`
  cursor: pointer;
  & > div > div:last-child {
      top: 35px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    margin-left: 16px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 0 0px 0 16px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin: 0 16px 0 0;
  }
`

const FeedButton = () => {
  const history = useHistory();
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const { t } = useTranslation();

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };

  if (isTab) {
    return null;
  }

  return (
    <Wrapper onClick={() => history.push('/feed')}>
      <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper}
                   text={t("hints.feed")}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.6817 23.6317H5.97884C5.6123 23.6317 5.31519 23.9288 5.31519 24.2953C5.31519 24.6618 5.6123 24.959 5.97884 24.959H12.6817C13.0482 24.959 13.3454 24.6618 13.3454 24.2953C13.3454 23.9288 13.0482 23.6317 12.6817 23.6317ZM22.7028 23.6317H16C15.6334 23.6317 15.3363 23.9288 15.3363 24.2953C15.3363 24.6618 15.6334 24.959 16 24.959H22.7028C23.0693 24.959 23.3665 24.6618 23.3665 24.2953C23.3665 23.9288 23.0693 23.6317 22.7028 23.6317ZM22.7028 7.04041H5.97884C5.6123 7.04041 5.31519 7.33752 5.31519 7.70406C5.31519 8.07059 5.6123 8.36771 5.97884 8.36771H22.7028C23.0693 8.36771 23.3665 8.07059 23.3665 7.70406C23.3665 7.33752 23.0693 7.04041 22.7028 7.04041ZM22.7028 10.3587H16C15.6334 10.3587 15.3363 10.6558 15.3363 11.0223C15.3363 11.3888 15.6334 11.686 16 11.686H22.7028C23.0693 11.686 23.3665 11.3888 23.3665 11.0223C23.3665 10.6558 23.0693 10.3587 22.7028 10.3587ZM22.7028 13.6769H16C15.6334 13.6769 15.3363 13.974 15.3363 14.3406C15.3363 14.7071 15.6334 15.0042 16 15.0042H22.7028C23.0693 15.0042 23.3665 14.7071 23.3665 14.3406C23.3665 13.974 23.0693 13.6769 22.7028 13.6769ZM22.7028 16.9952H16C15.6334 16.9952 15.3363 17.2923 15.3363 17.6588C15.3363 18.0253 15.6334 18.3225 16 18.3225H22.7028C23.0693 18.3225 23.3665 18.0253 23.3665 17.6588C23.3665 17.2923 23.0693 16.9952 22.7028 16.9952ZM22.7028 20.3134H16C15.6334 20.3134 15.3363 20.6105 15.3363 20.9771C15.3363 21.3436 15.6334 21.6407 16 21.6407H22.7028C23.0693 21.6407 23.3665 21.3436 23.3665 20.9771C23.3665 20.6105 23.0693 20.3134 22.7028 20.3134ZM12.6817 20.3134H5.97884C5.6123 20.3134 5.31519 20.6105 5.31519 20.9771C5.31519 21.3436 5.6123 21.6407 5.97884 21.6407H12.6817C13.0482 21.6407 13.3454 21.3436 13.3454 20.9771C13.3454 20.6105 13.0482 20.3134 12.6817 20.3134ZM12.6817 10.3587H5.97884C5.6123 10.3587 5.31519 10.6558 5.31519 11.0223V17.7252C5.31519 18.0917 5.6123 18.3888 5.97884 18.3888H12.6817C13.0482 18.3888 13.3454 18.0917 13.3454 17.7252V11.0223C13.3454 10.6558 13.0482 10.3587 12.6817 10.3587ZM12.0181 17.0615H6.64249V11.686H12.0181V17.0615Z" fill="#909090"/>
          <path d="M29.3394 6.37684H27.3485V4.38589C27.3485 3.65402 26.753 3.05859 26.0212 3.05859H2.66067C1.9288 3.05859 1.33337 3.65402 1.33337 4.38589V25.6227C1.33337 27.4524 2.82194 28.9409 4.65162 28.9409H27.3485C29.1781 28.9409 30.6667 27.4524 30.6667 25.6227V7.70414C30.6667 6.97227 30.0713 6.37684 29.3394 6.37684ZM29.3394 25.6227C29.3394 26.7205 28.4463 27.6136 27.3485 27.6136H4.65162C3.55381 27.6136 2.66067 26.7205 2.66067 25.6227V4.38589H26.0212V24.6272C26.0212 25.5421 26.7654 26.2863 27.6803 26.2863C28.0468 26.2863 28.3439 25.9892 28.3439 25.6227C28.3439 25.2562 28.0468 24.959 27.6803 24.959C27.4973 24.959 27.3485 24.8102 27.3485 24.6272V7.70414H29.3394V25.6227Z" fill="#909090"/>
        </svg>
      </HintTooltip>
    </Wrapper>
  )
}

export default FeedButton;import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { AppTester } from "../../../supporting";
import { useTranslation } from "react-i18next";
import { LayoutConst } from 'core';

const Wrapper = styled(FlexBox)`
  cursor: pointer;
  & > div > div:last-child {
      top: 35px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    margin-left: 16px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 0 0px 0 16px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin: 0 16px 0 0;
  }
`

const FeedButton = () => {
  const history = useHistory();
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const { t } = useTranslation();

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };

  if (isTab) {
    return null;
  }

  return (
    <Wrapper onClick={() => history.push('/feed')}>
      <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper}
                   text={t("hints.feed")}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.6817 23.6317H5.97884C5.6123 23.6317 5.31519 23.9288 5.31519 24.2953C5.31519 24.6618 5.6123 24.959 5.97884 24.959H12.6817C13.0482 24.959 13.3454 24.6618 13.3454 24.2953C13.3454 23.9288 13.0482 23.6317 12.6817 23.6317ZM22.7028 23.6317H16C15.6334 23.6317 15.3363 23.9288 15.3363 24.2953C15.3363 24.6618 15.6334 24.959 16 24.959H22.7028C23.0693 24.959 23.3665 24.6618 23.3665 24.2953C23.3665 23.9288 23.0693 23.6317 22.7028 23.6317ZM22.7028 7.04041H5.97884C5.6123 7.04041 5.31519 7.33752 5.31519 7.70406C5.31519 8.07059 5.6123 8.36771 5.97884 8.36771H22.7028C23.0693 8.36771 23.3665 8.07059 23.3665 7.70406C23.3665 7.33752 23.0693 7.04041 22.7028 7.04041ZM22.7028 10.3587H16C15.6334 10.3587 15.3363 10.6558 15.3363 11.0223C15.3363 11.3888 15.6334 11.686 16 11.686H22.7028C23.0693 11.686 23.3665 11.3888 23.3665 11.0223C23.3665 10.6558 23.0693 10.3587 22.7028 10.3587ZM22.7028 13.6769H16C15.6334 13.6769 15.3363 13.974 15.3363 14.3406C15.3363 14.7071 15.6334 15.0042 16 15.0042H22.7028C23.0693 15.0042 23.3665 14.7071 23.3665 14.3406C23.3665 13.974 23.0693 13.6769 22.7028 13.6769ZM22.7028 16.9952H16C15.6334 16.9952 15.3363 17.2923 15.3363 17.6588C15.3363 18.0253 15.6334 18.3225 16 18.3225H22.7028C23.0693 18.3225 23.3665 18.0253 23.3665 17.6588C23.3665 17.2923 23.0693 16.9952 22.7028 16.9952ZM22.7028 20.3134H16C15.6334 20.3134 15.3363 20.6105 15.3363 20.9771C15.3363 21.3436 15.6334 21.6407 16 21.6407H22.7028C23.0693 21.6407 23.3665 21.3436 23.3665 20.9771C23.3665 20.6105 23.0693 20.3134 22.7028 20.3134ZM12.6817 20.3134H5.97884C5.6123 20.3134 5.31519 20.6105 5.31519 20.9771C5.31519 21.3436 5.6123 21.6407 5.97884 21.6407H12.6817C13.0482 21.6407 13.3454 21.3436 13.3454 20.9771C13.3454 20.6105 13.0482 20.3134 12.6817 20.3134ZM12.6817 10.3587H5.97884C5.6123 10.3587 5.31519 10.6558 5.31519 11.0223V17.7252C5.31519 18.0917 5.6123 18.3888 5.97884 18.3888H12.6817C13.0482 18.3888 13.3454 18.0917 13.3454 17.7252V11.0223C13.3454 10.6558 13.0482 10.3587 12.6817 10.3587ZM12.0181 17.0615H6.64249V11.686H12.0181V17.0615Z" fill="#909090"/>
          <path d="M29.3394 6.37684H27.3485V4.38589C27.3485 3.65402 26.753 3.05859 26.0212 3.05859H2.66067C1.9288 3.05859 1.33337 3.65402 1.33337 4.38589V25.6227C1.33337 27.4524 2.82194 28.9409 4.65162 28.9409H27.3485C29.1781 28.9409 30.6667 27.4524 30.6667 25.6227V7.70414C30.6667 6.97227 30.0713 6.37684 29.3394 6.37684ZM29.3394 25.6227C29.3394 26.7205 28.4463 27.6136 27.3485 27.6136H4.65162C3.55381 27.6136 2.66067 26.7205 2.66067 25.6227V4.38589H26.0212V24.6272C26.0212 25.5421 26.7654 26.2863 27.6803 26.2863C28.0468 26.2863 28.3439 25.9892 28.3439 25.6227C28.3439 25.2562 28.0468 24.959 27.6803 24.959C27.4973 24.959 27.3485 24.8102 27.3485 24.6272V7.70414H29.3394V25.6227Z" fill="#909090"/>
        </svg>
      </HintTooltip>
    </Wrapper>
  )
}

export default FeedButton;